import React, { useState, useEffect, useMemo, useRef } from "react";
import { Button, Form, Modal, Row, Col, Spinner, Badge } from "react-bootstrap";
import {
  BsPencil,
  BsTrash,
  BsClockHistory,
  BsChat,
  BsPaperclip,
  BsExclamationTriangle,
  BsPlus,
} from "react-icons/bs";
import Select, { components } from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import {
  apiGet,
  apiPost,
  apiPut,
  apiDelete,
  apiPostFormData,
} from "../../api/api";
import CommentsModal from "../modals/CommentsModal";
import AttachmentsModal from "../modals/AttachmentsModal";
import DeadlineHistoryModal from "../modals/DeadlineHistoryModal";
import ActionCommentsModal from "../modals/ActionCommentsModal";
import TaskTable from "./TaskTable";
import "../../styles/addtaskstyle.css";
import { fetchFileSize, formatFileSize } from "../../utils/fileUtils";

const TaskManagement = ({
  tasks,
  refreshTasks,
  roleName,
  userId,
  userName,
}) => {

  const ALLOWED_FILE_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpeg',
    'image/jpg',
    'image/png'
  ];
  const MAX_FILE_SIZE = 5 * 1024 * 1024;



  const speak = (text) => {
    if ('speechSynthesis' in window) {
      const speech = new SpeechSynthesisUtterance();
      speech.text = text;
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1.2;
      speech.lang = 'en-US';


      const voices = window.speechSynthesis.getVoices();
      const femaleVoice = voices.find(voice =>
        voice.name.includes('Female') ||
        voice.name.includes('woman') ||
        voice.name.includes('Zira')
      );

      speech.voice = femaleVoice || voices[0];
      window.speechSynthesis.speak(speech);
    }
  };


  const ConfirmToast = ({ message, onConfirm, onCancel }) => {
    return (
      <div style={{ maxWidth: '600px' }}>
        <div className="mb-3">
          <h6 className="mb-0 text-center meassage-text">{message}</h6>
        </div>
        <div className="d-flex justify-content-center gap-2">


          <Button className='yes-button' size="sm" onClick={onConfirm}>
            Yes
          </Button>
          <Button className='No-button' size="sm" onClick={onCancel}>
            No
          </Button>
        </div>
      </div>

    );
  };

  console.log(roleName);
  const [isLoading, setIsLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const fileInputRef = useRef(null);
  const [fileSizes, setFileSizes] = useState({});
  const [initialOfficer, setInitialOfficer] = useState([]);

  const [commentsModal, setCommentsModal] = useState({
    show: false,
    taskId: null,
    type: "officer",
    officerName: "",
    coordinatorName: "",
  });

  const [attachmentsModal, setAttachmentsModal] = useState({
    show: false,
    taskId: null,
    officerName: "",
    officerIds: "",
    onFileDelete: () => { },
  });

  const [deadlineHistoryModal, setDeadlineHistoryModal] = useState({
    visible: false,
    loading: false,
    deadlines: [],
    currentTaskId: null,
  });

  const [actionCommentsModal, setActionCommentsModal] = useState({
    show: false,
    taskId: null,
    comments: [],
    loading: false,
    coordinatorName: "",
  });



  const checkRemovePermission = (file) => {
    return (
      roleName === "SuperAdmin" ||
      roleName === "Admin" ||
      !file.createdByID ||
      (
        roleName === "TaskCoordinator" &&
        (
          file.createdByID === userId ||
          formData.selectedOfficerResponsible.some(
            (i) => i.value === file.createdByID
          )
        )
      )
    );
  };
  const [formData, setFormData] = useState({
    issueActionOrDecision: "",
    actionTakenOrStatus: "",
    selectedPriority: "",
    selectedCategory: "",
    AdditionalComments: "",
    selectedFiles: [],
    dateDecision: null,
    deadline: null,
    completionDate: null,
    selectedTaskCoordinator:
      roleName === "TaskCoordinator"
        ? { value: userId, label: userName }
        : null,
    selectedOfficerResponsible: [],
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentTaskId, setCurrentTaskId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [allUsers, setAllUsers] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [categories, setCategories] = useState([]);




  const validateFiles = (files) => {
    const existingFilesSize = formData.selectedFiles.reduce(
      (sum, file) => sum + (file.size || file.fileSize || 0),
      0
    );

    let newFilesSize = 0;
    const errors = [];

    for (const file of files) {
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        errors.push(`File type not allowed: ${file.name}. Allowed types: PDF, DOC, XLS, JPEG, JPG, PNG.`);
        continue;
      }

      if (file.size > MAX_FILE_SIZE) {
        errors.push(`File too large: ${file.name} (${formatFileSize(file.size)}). Max file size is 5MB.`);
        continue;
      }

      newFilesSize += file.size;
    }

    if (existingFilesSize + newFilesSize > MAX_FILE_SIZE) {
      errors.push(
        `Total size exceeds 5MB limit. Current total: ${formatFileSize(existingFilesSize)} + ${formatFileSize(newFilesSize)} = ${formatFileSize(existingFilesSize + newFilesSize)}`
      );
    }

    if (errors.length > 0) {
      return {
        valid: false,
        message: errors.join(' ')
      };
    }

    return { valid: true };
  };

  const getFileSizeInBytes = (file) => {
    if (file.size) return file.size;
    if (file.fileSize) return file.fileSize;
    if (file.attachmentID && fileSizes[file.attachmentID]) return fileSizes[file.attachmentID];
    return 0;
  };


  const calculateTotalSize = () => {
    return formData.selectedFiles.reduce(
      (sum, file) => sum + getFileSizeInBytes(file),
      0
    );
  };


  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const currentTotalSize = calculateTotalSize();
    let newFilesSize = 0;
    const validFiles = [];
    const errors = [];

    files.forEach(file => {

      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        errors.push(`File type not allowed: ${file.name}`);
        return;
      }


      if (file.size > MAX_FILE_SIZE) {
        errors.push(`${file.name} exceeds 5MB limit (${formatFileSize(file.size)})`);
        return;
      }


      if (currentTotalSize + newFilesSize + file.size > MAX_FILE_SIZE) {
        errors.push(`Adding ${file.name} would exceed 5MB total limit`);
        return;
      }

      newFilesSize += file.size;
      validFiles.push(file);
    });

    if (errors.length > 0) {
      toast.error(
        <div>
          {errors.map((error, i) => (
            <div key={i}>{error}</div>
          ))}
        </div>
      );
      e.target.value = '';
      return;
    }

    if (validFiles.length > 0) {
      setFormData(prev => ({
        ...prev,
        selectedFiles: [...prev.selectedFiles, ...validFiles],
      }));
      toast.success(`Added ${validFiles.length} file(s)`);
    }
    e.target.value = '';
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setIsLoading(true);
        const [usersRes, prioritiesRes, categoriesRes] = await Promise.all([
          apiGet("/User/GetAllUsers"),
          apiGet("/User/GetAllPriority"),
          apiGet("/User/GetAllCategories"),
        ]);

        if (usersRes?.isSuccess) setAllUsers(usersRes.data || []);
        if (prioritiesRes?.isSuccess) setPriorities(prioritiesRes.data || []);
        if (categoriesRes?.isSuccess) setCategories(categoriesRes.data || []);
      } catch (error) {
        console.error("Error fetching initial data:", error);
        toast.error("Failed to load initial data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchInitialData();
    refreshTasks();
  }, []);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.issueActionOrDecision.trim()) {
      newErrors.issueActionOrDecision = "Issue/Action/Decision is required";
    }

    if (!formData.selectedTaskCoordinator) {
      newErrors.taskCoordinator = "Task Coordinator is required";
    }

    if (!formData.selectedPriority) {
      newErrors.selectedPriority = "Task Priority is required";
    }

    if (!formData.dateDecision) {
      newErrors.dateDecision = "Decision Date is required";
    }

    if (!formData.deadline) {
      newErrors.deadline = "Deadline is required";
    }

    if (
      currentTaskId &&
      formData.selectedOfficerResponsible.find((i) => i.value === userId) &&
      !formData.AdditionalComments
    ) {
      newErrors.AdditionalComments =
        "Additional comments is require for officer.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    if (field === "dateDecision") {
      setFormData((prev) => ({
        ...prev,
        dateDecision: value,
        deadline: null,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const removeFile = async (index, id) => {
    const fileToRemove = formData.selectedFiles[index];

    if (!fileToRemove.attachmentID) {
      setFormData((prev) => {
        const newFiles = [...prev.selectedFiles];
        newFiles.splice(index, 1);
        return {
          ...prev,
          selectedFiles: newFiles,
        };
      });
      speak("Local file removed");
      return;
    }

    try {
      setIsLoading(true);
      const response = await apiDelete(`/TaskTracking/DeleteAttachment/${id}`);

      if (response?.isSuccess) {
        toast.success("Attachment deleted successfully");
        speak("Attachment deleted successfully");
        setFormData((prev) => {
          const newFiles = [...prev.selectedFiles];
          newFiles.splice(index, 1);
          return {
            ...prev,
            selectedFiles: newFiles,
          };
        });

        refreshTasks();
      } else {
        throw new Error(response?.message || "Failed to delete attachment");
      }
    } catch (error) {
      console.error("Error deleting attachment:", error);
      toast.error(error.message);
      speak("Error deleting attachment. " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddTask = () => {
    resetForm();
    setShowModal(true);
    setIsEditing(false);
    speak("Add new task form opened");
  };
// const handleEditTask = async (taskId) => {
//   try {
//     setIsLoading(true);
    
//     const response = await apiGet(`/TaskTracking/GetById/${taskId}`);

//     if (!response?.isSuccess) {
//       throw new Error(response?.message || "Failed to load task data");
//     }

//     const task = response.singleData;
//     const attachments = await fetchAttachments(taskId);

//     // Extract responsible officer IDs for permission checking
//     const responsibleOfficerIDs = task.responsibleOfficerIDs
//       .split(",")
//       .map((id, index) => parseInt(id.trim()));

//     console.log(responsibleOfficerIDs);

//     // Create updated form data with originalActionStatus
//     const formDataUpdate = {
//       issueActionOrDecision: task.issueActionOrDecision || "",
//       actionTakenOrStatus: task.actionTakenOrStatus || "",
//       originalActionStatus: task.actionTakenOrStatus || "", // NEW: Store original action status
//       selectedPriority: task.priorityID?.toString() || "",
//       selectedCategory: task.categoryID?.toString() || "",
//       AdditionalComments: task.additionalComments || "",
//       selectedFiles: attachments || [],
//       dateDecision: task.dateOfDecisionOrInitiation
//         ? new Date(task.dateOfDecisionOrInitiation)
//         : null,
//       deadline: task.deadline ? new Date(task.deadline) : null,
//       completionDate: task.actualCompletionDate
//         ? new Date(task.actualCompletionDate)
//         : null,
//       selectedTaskCoordinator: task.coordinatorIDs
//         ? {
//             value: parseInt(task.coordinatorIDs),
//             label: task.coordinatorNames || `Coordinator ${task.coordinatorIDs}`,
//           }
//         : null,
//       selectedOfficerResponsible: task.responsibleOfficerIDs
//         ? task.responsibleOfficerIDs.split(",").map((id, index) => ({
//             value: parseInt(id.trim()),
//             label:
//               task.officerNames?.split(",")[index]?.trim() ||
//               `Officer ${id.trim()}`,
//           }))
//         : [],
//     };

//     setInitialOfficer(responsibleOfficerIDs);
//     setFormData(formDataUpdate);
//     setCurrentTaskId(taskId);
    
//     // Determine edit permissions
//     const isResponsible = isUserResponsibleForTask(taskId);
    
//     // Set editing mode based on role and responsibility
//     if (
//       roleName == "SuperAdmin" ||
//       roleName == "Admin" ||
//       (roleName == "TaskCoordinator" && !isResponsible)
//     ) {
//       setIsEditing(false); // Full edit access
//     } else {
//       setIsEditing(true); // Restricted edit access
//     }
    
//     setShowModal(true);

//   } catch (error) {
//     console.error("Error in handleEditTask:", error);
//     toast.error(error.message || "Failed to load task for editing");
  
//   } finally {
//     setIsLoading(false);
//   }
// };


const handleEditTask = async (taskId) => {
  try {
    setIsLoading(true);
    const response = await apiGet(`/TaskTracking/GetById/${taskId}`);
    if (!response?.isSuccess) {
      throw new Error(response?.message || "Failed to load task data");
    }

    const task = response.singleData;
    const attachments = await fetchAttachments(taskId);
    const responsibleOfficerIds = task.responsibleOfficerIDs
      ?.split(",")
      .map((id) => parseInt(id.trim()));
    const formDataUpdate = {
      issueActionOrDecision: task.issueActionOrDecision || "",
      actionTakenOrStatus: task.actionTakenOrStatus || "",
      originalActionStatus: task.actionTakenOrStatus || "", 
      selectedPriority: task.priorityID?.toString() || "",
      selectedCategory: task.categoryID?.toString() || "",
      AdditionalComments: task.additionalComments || "",
      selectedFiles: attachments || [],
      dateDecision: task.dateOfDecisionOrInitiation
        ? new Date(task.dateOfDecisionOrInitiation)
        : null,
      deadline: task.deadline ? new Date(task.deadline) : null,
      completionDate: task.actualCompletionDate
        ? new Date(task.actualCompletionDate)
        : null,
      selectedTaskCoordinator: task.coordinatorIDs
        ? {
            value: parseInt(task.coordinatorIDs),
            label: task.coordinatorNames || `Coordinator ${task.coordinatorIDs}`,
          }
        : null,
      selectedOfficerResponsible: task.responsibleOfficerIDs
        ? task.responsibleOfficerIDs.split(",").map((id, index) => ({
            value: parseInt(id.trim()),
            label:
              task.officerNames?.split(",")[index]?.trim() ||
              `Officer ${id.trim()}`,
          }))
        : [],
    };

    setInitialOfficer(responsibleOfficerIds);
    setFormData(formDataUpdate);
    setCurrentTaskId(taskId);


    const isTaskCoordinator = roleName === "TaskCoordinator";
    const isTaskCreator = task.createdByID === userId;

  
    const isResponsible = responsibleOfficerIds?.includes(userId);

    if (roleName === "SuperAdmin" || roleName === "Admin") {
      setIsEditing(false); 
    } else if (isTaskCoordinator && (isTaskCreator || isResponsible)) {
      setIsEditing(false); 
    } else {
      setIsEditing(true);
    }


    setShowModal(true);
  } catch (error) {
    console.error("Error in handleEditTask:", error);
    toast.error(error.message || "Failed to load task for editing");
  } finally {
    setIsLoading(false);
  }
};

  const fetchAttachments = async (taskId) => {
    if (!taskId) return [];
    try {
      const response = await apiGet(`/TaskTracking/GetAttachments/${taskId}`);
      if (response?.data) {
        const sizes = {};
        await Promise.all(
          response.data.map(async (file) => {
            const size = await fetchFileSize(
              `${process.env.REACT_APP_API_BASE_URL}/uploads/tasks/TaskUpload/${file.fileName}`
            );
            console.log(size);
            if (size !== null) {
              sizes[file.attachmentID] = size;
            }
          })
        );
        setFileSizes((prev) => ({ ...prev, ...sizes }));
        return response.data.map((attachment) => ({
          ...attachment,
          url: `${process.env.REACT_APP_API_BASE_URL}/uploads/tasks/TaskUpload/${attachment.fileName}`,
          fileSize: attachment.fileSize || 0,
        }));
      }
      return [];
    } catch (error) {
      console.error("Error fetching attachments:", error);
      return [];
    }
  };

  const handleDeleteTask = async (taskId) => {
    const taskToDelete = tasks.find(t => t.taskID === taskId);
    const confirmMsg = `Are you sure you want to delete this task?`;

    window.speechSynthesis.cancel();
    speak(confirmMsg);

    toast.info(
      <ConfirmToast
        message={confirmMsg}
        onConfirm={async () => {
          toast.dismiss();
          try {
            setIsLoading(true);
            speak("Deleting task...");
            const response = await apiDelete(`/TaskTracking/Delete/${taskId}`);

            if (response?.isSuccess) {
              const msg = 'Task deleted successfully!';
              toast.success(<strong>{msg}</strong>, { autoClose: 5000 });
              speak(msg);
              refreshTasks();
            } else {
              throw new Error(response?.message || "Failed to delete task");
            }
          } catch (error) {
            console.error("Error deleting task:", error);
            toast.error(error.message);
            speak("Error deleting task. " + error.message);
          } finally {
            setIsLoading(false);
          }
        }}
        onCancel={() => {
          toast.dismiss();
          const cancelMsg = `Task deletion cancelled.`;
          speak(cancelMsg);
        }}
      />,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
        icon: false,
        className: 'custom-toast',
        bodyClassName: 'custom-toast-body',
        hideProgressBar: true,
      }
    );
  };

  const handleSubmit = async () => {
  if (isSubmitting) return;

  if (!validateForm()) {
    toast.error("Please fill out all required fields");
    speak("Please fill out all required fields");
    return;
  }

  setIsSubmitting(true);
  speak("Processing your request...");

  try {
  
    const dateDecision = formData.dateDecision
      ? new Date(
          formData.dateDecision.getTime() - 
          formData.dateDecision.getTimezoneOffset() * 60000
        )
      : null;

    const deadline = formData.deadline
      ? new Date(
          formData.deadline.getTime() - 
          formData.deadline.getTimezoneOffset() * 60000
        )
      : null;

    const completionDate = formData.completionDate
      ? new Date(
          formData.completionDate.getTime() - 
          formData.completionDate.getTimezoneOffset() * 60000
        )
      : null;

  
    const actionStatusChanged = currentTaskId 
      ? formData.actionTakenOrStatus?.trim() !== formData.originalActionStatus?.trim()
      : true; 


    const taskData = {
      IssueActionOrDecision: formData.issueActionOrDecision.trim(),
      ActionTakenOrStatus: formData.actionTakenOrStatus?.trim() || null,
      PriorityID: parseInt(formData.selectedPriority),
      DateOfDecisionOrInitiation: dateDecision?.toISOString(),
      Deadline: deadline?.toISOString(),
      ActualCompletionDate: completionDate?.toISOString(),
      CategoryID: formData.selectedCategory
        ? parseInt(formData.selectedCategory)
        : null,
      AdditionalComments: formData.AdditionalComments?.trim() || null,
      TaskCoordinatorID: formData.selectedTaskCoordinator?.value || null,
      Officers: formData.selectedOfficerResponsible?.map((officer) => ({
        OfficerID: officer.value,
        IsActive: true,
      })) || [],
      TaskAttachments: [],
      ExistingAttachmentIds: formData.selectedFiles
        ?.filter((file) => file.attachmentID)
        .map((file) => file.attachmentID) || [],
    
      ActionStatusComments: actionStatusChanged && formData.actionTakenOrStatus?.trim()
        ? [{
            ActionComment: formData.actionTakenOrStatus.trim(),
            TaskCoordinatorID: formData.selectedTaskCoordinator?.value || userId,
          }]
        : [],
    };
  
    const formDataToSend = new FormData();
    formDataToSend.append("TaskDataJson", JSON.stringify(taskData));

 
    formData.selectedFiles?.forEach((file) => {
      if (file instanceof File) {
        formDataToSend.append("Attachments", file);
      }
    });

  
    const response = currentTaskId
      ? await apiPut(`/TaskTracking/Update/${currentTaskId}`, formDataToSend)
      : await apiPostFormData("/TaskTracking/Create", formDataToSend);

    if (!response?.isSuccess) {
      throw new Error(response?.message || "Operation failed");
    }

  
    let successMessage = "";
    if (formData.completionDate && 
        ["SuperAdmin", "Admin", "TaskCoordinator", "OfficerResponsible"].includes(roleName)) {
      successMessage = "Task completed successfully!";
    } else {
      successMessage = currentTaskId
        ? "Task updated successfully"
        : "Task created successfully";
    }

    toast.success(successMessage);
    speak(successMessage);

 
    resetForm();
    setShowModal(false);
    refreshTasks();
  } catch (error) {
    console.error("Error:", error);
    const errorMsg = error.response?.data?.message || error.message;
    toast.error(errorMsg);
    speak("Error processing your request. " + errorMsg);
  } finally {
    setIsSubmitting(false);
  }
};


  const handleClose = () => {
    setShowModal(false);
    resetForm();
    speak("Task form closed");
  };

  const resetForm = () => {
    setFormData({
      issueActionOrDecision: "",
      actionTakenOrStatus: "",
      selectedPriority: "",
      selectedCategory: "",
      AdditionalComments: "",
      selectedFiles: [],
      dateDecision: null,
      deadline: null,
      completionDate: null,
      selectedTaskCoordinator:
        roleName === "TaskCoordinator"
          ? { value: userId, label: userName }
          : null,
      selectedOfficerResponsible: [],
    });
    setErrors({});
    setIsEditing(false);
    setCurrentTaskId(null);
  };

  const handleShowDeadlineHistory = async (taskId) => {
    try {
      setDeadlineHistoryModal((prev) => ({
        ...prev,
        visible: true,
        loading: true,
        currentTaskId: taskId,
      }));


      const response = await apiGet(`/TaskTracking/task-deadlines/${taskId}`);

      if (response?.isSuccess && response.data) {
        const sortedDeadlines = response.data.sort(
          (a, b) => new Date(b.changeDate) - new Date(a.changeDate)
        );

        setDeadlineHistoryModal((prev) => ({
          ...prev,
          deadlines: sortedDeadlines,
          loading: false,
        }));
        speak("Deadline history loaded");
      } else {
        setDeadlineHistoryModal((prev) => ({ ...prev, loading: false }));
        toast.error(response?.message || "No deadline history found");
        speak("No deadline history found for this task");
      }
    } catch (error) {
      console.error("Error fetching deadline history:", error);
      setDeadlineHistoryModal((prev) => ({ ...prev, loading: false }));
      toast.error("Failed to load deadline history");
      speak("Failed to load deadline history");
    }
  };

  const handleShowCoordinatorComments = (task) => {
    setCommentsModal({
      show: true,
      taskId: task.taskID,
      type: "coordinator",
      coordinatorName: task.coordinatorNames || "Coordinator",
      officerName: "",
    });
    speak("Showing coordinator comments");
  };

  const handleShowOfficerComments = (task) => {
    setCommentsModal({
      show: true,
      taskId: task.taskID,
      type: "officer",
      officerName: task.officerNames || "Officer",
      coordinatorName: "",
    });
    speak("Showing officer comments");
  };

  const handleShowAttachments = (task) => {
    setAttachmentsModal({
      show: true,
      taskId: task.taskID,
      officerName: task.officerNames || "Officer",
      officerIds: task.officerResponsibleIDList,
      onFileDelete: () => {
        refreshTasks();

        if (isEditing && currentTaskId === task.taskID) {
          fetchAttachments(task.taskID).then((attachments) => {
            setFormData((prev) => ({
              ...prev,
              selectedFiles: attachments,
            }));
          });
        }
      },
    });
    speak("Showing task attachments");
  };




  const taskCoordinatorOptions = useMemo(() => {
  if (roleName === "TaskCoordinator") {
    return [{ value: userId, label: userName }];
  }
 
  return allUsers
    .filter((user) => user.roleName?.toLowerCase() === "taskcoordinator")
    .map((user) => ({
      value: user.userID,
      label: user.username,
    }));
}, [allUsers, roleName, userId, userName]);

  const officerResponsibleOptions = useMemo(
    () =>
      allUsers
        .filter(
          (user) =>
            user.roleName?.toLowerCase() === "taskcoordinator" &&
            (!formData.selectedTaskCoordinator ||
              user.userID !== formData.selectedTaskCoordinator.value)
        )
        .map((user) => ({
          value: user.userID,
          label: user.username,
        })),
    [allUsers, formData.selectedTaskCoordinator]
  );

  const priorityOptions = useMemo(
    () =>
      priorities.map((priority) => ({
        value: priority.priorityID.toString(),
        label: priority.priorityName,
      })),
    [priorities]
  );

  const categoryOptions = useMemo(
    () =>
      categories.map((category) => ({
        value: category.categoryID.toString(),
        label: category.categoryName,
      })),
    [categories]
  );

  const fetchActionComments = async (taskID) => {
    if (!taskID || isNaN(taskID)) {
      toast.error("Invalid Task ID");
      speak("Invalid Task ID");
      return;
    }

    try {
      setActionCommentsModal((prev) => ({ ...prev, loading: true }));


      const response = await apiGet(`/TaskTracking/ActionComments/${taskID}`);
      if (response) {
        const formattedComments = response
          .map((comment) => ({
            ...comment,
            createdDate: comment.createdDate
              ? new Date(comment.createdDate)
              : new Date(),
          }))
          .sort((a, b) => b.createdDate - a.createdDate);

        setActionCommentsModal((prev) => ({
          ...prev,
          comments: formattedComments,
          loading: false,
        }));
        speak("Action comments loaded");
      } else {
        setActionCommentsModal((prev) => ({ ...prev, loading: false }));
        toast.error(response?.errors?.join(", ") || "No action comments found");
        speak("No action comments found");
      }
    } catch (error) {
      console.error("Error fetching action comments:", error);
      setActionCommentsModal((prev) => ({ ...prev, loading: false }));
      const errorMsg =
        error.response?.data?.title ||
        error.response?.data?.errors?.taskID?.join(", ") ||
        "Failed to load action comments";
      toast.error(errorMsg);
      speak("Failed to load action comments");
    }
  };

  const handleShowActionComments = (task) => {
    if (!task?.taskID) {
      toast.error("Invalid task data");
      speak("Invalid task data");
      return;
    }

    setActionCommentsModal({
      show: true,
      taskId: task.taskID,
      comments: [],
      loading: true,
      coordinatorName: task.coordinatorNames || " Task Coordinator",
    });


    fetchActionComments(task.taskID);
  };

  const taskTableProps = {
    tasks: tasks,
    isLoading: isLoading,
    filterText: filterText,
    onEditTask: handleEditTask,
    onDeleteTask: handleDeleteTask,
    onShowDeadlineHistory: handleShowDeadlineHistory,
    onShowCoordinatorComments: handleShowCoordinatorComments,
    onShowOfficerComments: handleShowOfficerComments,
    onShowAttachments: handleShowAttachments,
    onShowActionComments: handleShowActionComments,
    isEditing: isEditing,
    roleName: roleName,
    userId: userId,
    userName: userName,
  };

  const shouldShowAllFields = useMemo(() => {
    return ["SuperAdmin", "Admin", "TaskCoordinator"].includes(roleName);
  }, [roleName]);

  const isUserResponsibleForTask = (taskId) => {
    const task = tasks.find((t) => t.taskID === taskId);
    if (!task) return false;

    const responsibleOfficerIds = task.officerResponsibleIDList
      ?.split(",")
      .map((id) => parseInt(id.trim()));
    return responsibleOfficerIds?.includes(userId);
  };

  const shouldShowRestrictedFields = useMemo(() => {
    if (roleName === "SuperAdmin") return true;
    if (roleName === "TaskCoordinator" && isUserResponsibleForTask) return true;
    if (roleName === "OfficerResponsible") return true;
    return false;
  }, [roleName, isUserResponsibleForTask]);

  const isOfficerResponsible = roleName === "OfficerResponsible";
  const showMinimalFields = isOfficerResponsible && isEditing;

  const MultiValueRemove = (props) => {
    console.log(": ", initialOfficer);
    const isInitial = initialOfficer.find((item) => item === props.data.value);
    console.log(isInitial, props.data.value);

    if (!isEditing) {
      return <components.MultiValueRemove {...props} />;
    }
    if (isInitial) {
      return null;
    }

    return <components.MultiValueRemove {...props} />;
  };

  return (
    <div className="task-management">
   <div className="d-flex flex-column flex-lg-row flex-md-row justify-content-md-between  justify-content-center justify-content-lg-between mb-3">
  <Form.Control
    type="text"
    placeholder="Search tasks..."
    onChange={(e) => setFilterText(e.target.value)}
     style={{ width: "300px"  }}
    className="mb-2 mb-lg-0 searchinputdash"
  />
  {roleName !== "Viewer" && (
    <Button
      variant="btn-primary"
       
      className="btn-fontweight btn-btn-primary margin-button10"
      onClick={handleAddTask}
    >
      Add Task
    </Button>
  )}
</div>

      <div className="card shadow-sm rounded-4 py-4 px-0 mx-0 border-0 bg-white mb-custom">
        <TaskTable {...taskTableProps} />
      </div>

      <Modal show={showModal} onHide={handleClose} size="xl" centered>
        <Modal.Header closeButton className="modal-customheader">
          {currentTaskId > 0 &&
            (roleName == "SuperAdmin" ||
              roleName == "Admin" ||
              roleName == "TaskCoordinator") ? (
            <Modal.Title className="fw-bold fs-4 custom-modaltitle">Edit Task</Modal.Title>
          ) : (
            <Modal.Title className="fw-bold fs-4 custom-modaltitle">
              {isEditing ? "Edit Task" : "Create New Task "}
            </Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <Form className="px-1">
            {showMinimalFields ? (
              <Row className="mb-4">
                <Col md={6}>
                  <Form.Group controlId="additionalComments">
                    <Form.Label className="fw-semibold">
                      Additional Comments
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      className="rounded-3 shadow-sm"
                      value={formData.AdditionalComments}
                      onChange={(e) =>
                        handleInputChange(
                          "AdditionalComments",
                          e.target.value
                        )
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
            ) : (
              <>
                <Row className="mb-2">
                  <Col md={6}>
                    <Form.Group controlId="issue">
                      <Form.Label className="fw-semibold">
                        Issue/Action/Decision <span className="text-danger">*</span>
                      </Form.Label>

                      <Form.Control
                        as="textarea"
                        rows={2}
                        maxLength={800} // ✅ Limit characters
                        value={formData.issueActionOrDecision}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFormData({ ...formData, issueActionOrDecision: value });
                          if (errors.issueActionOrDecision && value.trim() !== "") {
                            setErrors(prev => ({ ...prev, issueActionOrDecision: null }));
                          }
                        }}
                        isInvalid={!!errors.issueActionOrDecision}
                         disabled={isEditing}
                      />

                      {/* Validation feedback */}
                      <Form.Control.Feedback type="invalid" className="custom-invalidtext">
                        {errors.issueActionOrDecision}
                      </Form.Control.Feedback>

                      {/* Note below in red */}
                      <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
                        Maximum 800 characters allowed. ({formData.issueActionOrDecision.length}/800)
                      </div>
                    </Form.Group>

                  </Col>
                  <Col md={6}>
  <Form.Group controlId="actionTaken">
    <Form.Label className="fw-semibold">
      Action Taken/Status
    </Form.Label>
    <Form.Control
      as="textarea"
      rows={2}
      className="rounded-3 shadow-sm"
      maxLength={800} // ✅ Add character limit
      value={formData.actionTakenOrStatus}
      onChange={(e) =>
        handleInputChange(
          "actionTakenOrStatus",
          e.target.value
        )
      }
      disabled={isEditing}
    />
    {/* Character count display in red */}
    <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
      Maximum 800 characters allowed. ({formData.actionTakenOrStatus.length}/800)
    </div>
  </Form.Group>
</Col>
              
                </Row>
                   <Row className="mb-3">
             <Col md={6}>
                    <Form.Group controlId="taskCoordinator">
  <Form.Label className="fw-semibold">
    Task Coordinator <span className="text-danger">*</span>
  </Form.Label>
  <Select
    options={taskCoordinatorOptions}
    isLoading={isLoading}
    onChange={(selected) => {
      handleInputChange("selectedTaskCoordinator", selected);
      if (errors.taskCoordinator && selected) {
        setErrors((prev) => ({ ...prev, taskCoordinator: null }));
      }
    }}
    value={formData.selectedTaskCoordinator}
    className="shadow-sm"
    placeholder="Select Task Coordinator"
    isClearable={roleName !== "TaskCoordinator"} 
    isSearchable={roleName !== "TaskCoordinator"} 
    isDisabled={isEditing || roleName === "TaskCoordinator"} 
  />
  {errors.taskCoordinator && (
    <Form.Text className="text-danger">
      {errors.taskCoordinator}
    </Form.Text>
  )}
</Form.Group>
               </Col>
               
                  <Col md={6}>
                    <Form.Group controlId="officerResponsible">
                      <Form.Label className="fw-semibold">
                        Officer Responsible{" "}
                      </Form.Label>
                      <Select
                        options={officerResponsibleOptions}
                        isMulti
                        isLoading={isLoading}
                        onChange={(selected) =>
                          handleInputChange(
                            "selectedOfficerResponsible",
                            selected
                          )
                        }
                        value={formData.selectedOfficerResponsible}
                        components={{ MultiValueRemove }}
                        className="shadow-sm"
                        placeholder="Select Officer(s)"
                        isClearable={!isEditing}
                        isSearchable
                        isDisabled={isEditing}
                      />
                      {errors.officerResponsible && (
                        <Form.Text className="text-danger">
                          {errors.officerResponsible}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                   </Row>

                <Row className="mb-3">

                  <Col md={6}>
                    <Form.Group controlId="priority">
                      <Form.Label className="fw-semibold">
                        Priority
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        options={priorityOptions}
                        isLoading={isLoading}
                        onChange={(selected) =>
                          handleInputChange("selectedPriority", selected?.value || "")
                        }
                        value={formData.selectedPriority
                          ? priorityOptions.find(opt => opt.value === formData.selectedPriority)
                          : null
                        }
                        className="shadow-sm"
                        placeholder="Select Priority"
                        isClearable
                        isSearchable
                        isDisabled={isEditing}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="category">
                      <Form.Label className="fw-semibold">Category</Form.Label>
                      <Select
                        options={categoryOptions}
                        isLoading={isLoading}
                        onChange={(selected) =>
                          handleInputChange("selectedCategory", selected?.value || "")
                        }
                        value={formData.selectedCategory
                          ? categoryOptions.find(opt => opt.value === formData.selectedCategory)
                          : null
                        }
                        className="shadow-sm"
                        placeholder="Select Category"
                        isClearable
                        isSearchable
                        isDisabled={isEditing}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3">

                 <Col md={6}>
  <Form.Group controlId="additionalComments">
    <Form.Label className="fw-semibold">
      Additional Comments
      {currentTaskId &&
        formData.selectedOfficerResponsible.find(
          (i) => i.value === userId
        ) && <span className="text-danger">*</span>}
    </Form.Label>
    <Form.Control
      as="textarea"
      rows={2}
      className="rounded-3 shadow-sm"
      maxLength={800} // ✅ Add character limit
      style={{
        cursor:
          (["SuperAdmin", "Admin", "TaskCoordinator"].includes(roleName) && !currentTaskId)
            ? "no-drop"
            : "auto",
        backgroundColor:
          (["SuperAdmin", "Admin", "TaskCoordinator"].includes(roleName) && !currentTaskId)
            ? "#e9ecef"
            : "white",
      }}
      value={formData.AdditionalComments}
      onChange={(e) =>
        handleInputChange("AdditionalComments", e.target.value)
      }
      disabled={
        roleName === "Viewer" ||
        (["SuperAdmin", "Admin", "TaskCoordinator"].includes(roleName) && !currentTaskId)
      }
    />
    {/* Character count display in red */}
    <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
      Maximum 800 characters allowed. ({formData.AdditionalComments.length}/800)
    </div>
  </Form.Group>
</Col>


<Col md={6}>
  <Form.Group controlId="dateDecision">
    <Form.Label className="fw-semibold">
      Decision Date <span className="text-danger">*</span>
    </Form.Label>
<DatePicker
  selected={formData.dateDecision}
  onChange={(date) => {
    handleInputChange("dateDecision", date);
    if (errors.dateDecision && date) {
      setErrors((prev) => ({ ...prev, dateDecision: null }));
    }
  }}
  className="form-control shadow-sm"
  dateFormat="dd-MM-yyyy"
  placeholderText="Select date"
  todayButton="Today"
  isClearable={false}
  maxDate={new Date()}   
  disabled={isEditing}
/>

    {errors.dateDecision && (
      <Form.Text className="text-danger">
        {errors.dateDecision}
      </Form.Text>
    )}
  </Form.Group>
</Col>

             

                </Row>
                  <Row className="mb-3">
                         <Col md={6}>
                    <Form.Group controlId="deadline">
                      <Form.Label className="fw-semibold">
                        Deadline <span className="text-danger">*</span>
                      </Form.Label>
                      <DatePicker
                        selected={formData.deadline}
                        onChange={(date) => {
                          handleInputChange("deadline", date);
                          if (errors.deadline && date) {
                            setErrors((prev) => ({ ...prev, deadline: null }));
                          }
                        }}
                        className="form-control shadow-sm"
                        dateFormat="dd-MM-yyyy"
                        placeholderText="Select date"
                        minDate={formData.dateDecision || new Date()}
                        disabled={!formData.dateDecision || isEditing}
                      />
                      {errors.deadline && (
                        <Form.Text className="text-danger">
                          {errors.deadline}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                    <Col md={6}>
                    <Form.Group controlId="completionDate">
                      <Form.Label className="fw-semibold">
                        Completion Date
                      </Form.Label>
                      <DatePicker
                        selected={formData.completionDate}
                        onChange={(date) => handleInputChange("completionDate", date)}
                        className="form-control shadow-sm"
                        dateFormat="dd-MM-yyyy"
                        placeholderText="Select date"
                        minDate={formData.dateDecision}
                        maxDate={new Date()}
                        disabled={!currentTaskId || roleName === "Viewer"}
                      />
                    </Form.Group>

                  </Col>
                   </Row>

                <Row className="mb-2">

                
                  <Col md={12}>



                    <Form.Group controlId="fileUpload" className="mb-4">
                      <Form.Label className="fw-semibold d-flex align-items-center">
                        Attachments
                        <Badge bg="secondary" className="ms-2">
                          {formatFileSize(calculateTotalSize())}/5MB
                        </Badge>
                        {calculateTotalSize() > MAX_FILE_SIZE && (
                          <Badge bg="danger" className="ms-2">
                            Size exceeded!
                          </Badge>
                        )}
                      </Form.Label>

                      <Form.Control
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        ref={fileInputRef}
                        className="shadow-sm border-2"
                        disabled={
                          roleName === "Viewer" ||
                          calculateTotalSize() >= MAX_FILE_SIZE
                        }
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png"
                      />

                      <Form.Text className="text-muted d-block mt-2">
                        <small  >
                          Maximum 5MB total. Allowed: PDF, DOC, XLS, JPEG, JPG, PNG.
                          {calculateTotalSize() > MAX_FILE_SIZE && (
                            <span className="text-danger ms-2">
                              Please remove files to stay under 5MB limit
                            </span>
                          )}
                        </small>
                      </Form.Text>

                      {formData.selectedFiles.length > 0 && (
                        <div className="mt-3">
                          <div className="alert alert-warning py-2 mb-2" role="alert">
                            <small>
                              <BsExclamationTriangle className="me-1" />
                              {calculateTotalSize() > MAX_FILE_SIZE ? (
                                <span>
                                  <strong>Warning: </strong>
                                  Total size exceeds 5MB limit. Remove files to submit.
                                </span>
                              ) : (
                                `You have ${formatFileSize(MAX_FILE_SIZE - calculateTotalSize())} remaining`
                              )}
                            </small>
                          </div>

                          <ul className="list-group border-0">
                            {formData.selectedFiles.map((file, index) => {
                              const fileName = file.name || file.fileName || "Unnamed File";
                              const fileSize = getFileSizeInBytes(file);
                              const fileSizeMB = formatFileSize(fileSize);
                              const isOversized = fileSize > MAX_FILE_SIZE;
                              const canRemove = checkRemovePermission(file);

                              return (
                                <li
                                  key={index}
                                  className={`list-group-item d-flex justify-content-between align-items-center ${isOversized ? "list-group-item-danger" : ""
                                    }`}
                                >
                                  <div className="d-flex align-items-center flex-grow-1">
                                    <BsPaperclip className="me-2 flex-shrink-0" />
                                    <div className="d-flex flex-column overflow-hidden">
                                      <span className="text-truncate" style={{ maxWidth: '250px' }}>
                                        {fileName}
                                      </span>
                                      <small className={`text-muted ${isOversized ? "text-danger" : ""}`}>
                                        {fileSizeMB}
                                        {isOversized && " (Exceeds individual file limit)"}
                                      </small>
                                    </div>
                                  </div>

                                  {canRemove && (
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      className="ms-2 flex-shrink-0"
                                      onClick={() => removeFile(index, file.attachmentID)}
                                      disabled={isLoading}
                                      aria-label={`Remove ${fileName}`}
                                    >
                                      {isLoading ? (
                                        <Spinner animation="border" size="sm" />
                                      ) : (
                                        <BsTrash />
                                      )}
                                    </Button>
                                  )}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}



            <div className="d-flex justify-content-lg-end justify-content-center gap-2 mt-4 py-2">
              {!isEditing && (
                <Button
                  variant="secondary"
                  className="reset-btn"
                  style={{ backgroundColor: '#6c757d', color: "#fff" }}
                  onClick={resetForm}
                  disabled={isSubmitting}
                >
                  Reset
                </Button>
              )}
              {currentTaskId > 0 &&
                (roleName == "SuperAdmin" ||
                  roleName == "Admin" ||
                  roleName == "TaskCoordinator") ? (
                <Button
                  variant="btn-primary"
                  onClick={handleSubmit}
                  disabled={isSubmitting || roleName === "Viewer"}
                >
                  {isSubmitting ? (
                    <>
                      {currentTaskId > 0 ? "Updating..." : "Creating..."}
                    </>
                  ) : currentTaskId > 0 ? (
                    "Update Task"
                  ) : (
                    "Create Task"
                  )}
                </Button>
              ) : (
                <Button
                  variant="btn-primary"
                  className="add-taskbtn2"
                  onClick={handleSubmit}
                  disabled={isSubmitting || roleName === "Viewer"}
                >
                  {isSubmitting ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      {isEditing ? "Updating..." : "Creating..."}
                    </>
                  ) : isEditing ? (
                    "Update Task"
                  ) : (
                    "Create Task"
                  )}
                </Button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <CommentsModal
        show={commentsModal.show}
        onHide={() => setCommentsModal((prev) => ({ ...prev, show: false }))}
        taskId={commentsModal.taskId}
        type={commentsModal.type}
        officerName={commentsModal.officerName}
        coordinatorName={commentsModal.coordinatorName}
      />

      <AttachmentsModal
        show={attachmentsModal.show}
        onHide={() => setAttachmentsModal((prev) => ({ ...prev, show: false }))}
        taskId={attachmentsModal.taskId}
        officerName={attachmentsModal.officerName}
        officerIds={attachmentsModal.officerIds}
        onFileDelete={attachmentsModal.onFileDelete}
        roleName={roleName}
        userId={userId}
      />

      <DeadlineHistoryModal
        show={deadlineHistoryModal.visible}
        onHide={() =>
          setDeadlineHistoryModal((prev) => ({ ...prev, visible: false }))
        }
        deadlines={deadlineHistoryModal.deadlines}
        loading={deadlineHistoryModal.loading}
        taskId={deadlineHistoryModal.currentTaskId}
      />

      <ActionCommentsModal
        show={actionCommentsModal.show}
        onHide={() =>
          setActionCommentsModal((prev) => ({ ...prev, show: false }))
        }
        taskId={actionCommentsModal.taskId}
        comments={actionCommentsModal.comments}
        loading={actionCommentsModal.loading}
        coordinatorName={actionCommentsModal.coordinatorName}
        fetchActionComments={fetchActionComments}
      />
    </div>
  );
};

export default TaskManagement;